module.exports = __webpack_public_path__ + "img/icon-ve_dahuy.8b28568c.svg";